/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_Category_OtherInputs */

const vi_whats_new_category_other = /** @type {(inputs: Whats_New_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật`)
};

/**

* @param {Whats_New_Category_OtherInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_category_other = /** @type {((inputs?: Whats_New_Category_OtherInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_Category_OtherInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_category_other(inputs)
});